import deliveryStatusLevels from '../../../helpers/lists/deliveryStatusLevels';

export default {
  MERCHANT_ACTIVITY_REGISTERED(state, payload) {
    state.merchantActivity = payload;
  },
  NEW_MESSAGE_RECEIVED(state, payload) {
    payload.message = { ...payload.message, ...payload.data };
    delete payload.data;
    if (payload.message.sender_icon) {
      if (payload.message.sender_icon.dark) {
        payload.message.sender_icon.dark = payload.message.sender_icon.dark.replaceAll('\\/', '/');
      }
      if (payload.message.sender_icon.grey) {
        payload.message.sender_icon.grey = payload.message.sender_icon.grey.replaceAll('\\/', '/');
      }
      if (payload.message.sender_icon.light) {
        payload.message.sender_icon.light = payload.message.sender_icon.light.replaceAll('\\/', '/');
      }
      if (payload.message.sender_icon.red) {
        payload.message.sender_icon.red = payload.message.sender_icon.red.replaceAll('\\/', '/');
      }
    }
    state.newMessageConversation = payload;
  },
  SENT_MESSAGE_STATUS_CHANGED(state, payload) {
    // update the message status for the chat in the cache
    if (this.state.chat.chatFastReload[payload.conversation_uid]) {
      let targetMessage;
      let targetMessageIndex;
      if (payload.message) {
        targetMessageIndex = this.state.chat.chatFastReload[payload.conversation_uid].data.findIndex(message => message.sid === payload.message.sid || message.sid === payload.message.temp_sid || message.id === payload.message.sid);
        targetMessage = this.state.chat.chatFastReload[payload.conversation_uid].data[targetMessageIndex];
      } else {
        targetMessageIndex = this.state.chat.chatFastReload[payload.conversation_uid].data.findIndex(message => message.sid === payload.sid || message.id === payload.sid);
        targetMessage = this.state.chat.chatFastReload[payload.conversation_uid].data[targetMessageIndex];
      }

      if (targetMessage) {
        if (deliveryStatusLevels.indexOf(targetMessage.status) < deliveryStatusLevels.indexOf(payload.status)) {
          targetMessage.status = payload.message ? payload.message.status : payload.status;
        }
        if (payload.error_message) {
          targetMessage.error_message = payload.error_message;
        }
      }

      // TODO on rewrite this will be processed on message load
      const maxWhileCount = 100;
      let whileCount = 0;
      const status = payload.message ? payload.message.status : payload.status;
      while (
        this.state.chat.chatFastReload[payload.conversation_uid].data[targetMessageIndex] &&
        whileCount < maxWhileCount
      ) {
        whileCount++;
        targetMessageIndex++;
        if (
          targetMessageIndex >= 0 &&
          this.state.chat.chatFastReload[payload.conversation_uid].data[targetMessageIndex] &&
          this.state.chat.chatFastReload[payload.conversation_uid].data[targetMessageIndex].direction === 'outbound' &&
          ['sent', 'delivered'].includes(this.state.chat.chatFastReload[payload.conversation_uid].data[targetMessageIndex].status) &&
          ['delivered', 'read'].includes(status) &&
          this.state.chat.chatFastReload[payload.conversation_uid].data[targetMessageIndex].status !== status
        ) {
          this.state.chat.chatFastReload[payload.conversation_uid].data[targetMessageIndex].status = payload.message ? payload.message.status : payload.status;
        }
      }
    }

    const sentMessageStatus = {
      conversation_uid: payload.conversation_uid,
      sid: payload.message ? (payload.message.id || payload.messge.sid) : (payload.id || payload.sid),
      status: payload.message ? payload.message.status : payload.status,
    };

    if (payload.error_message) {
      sentMessageStatus.error_message = payload.error_message;
    }

    state.sentMessageStatus = { ...sentMessageStatus };

    if (this.state.chat.messageCountChange > 100) {
      this.state.chat.messageCountChange = 0;
    } else {
      this.state.chat.messageCountChange++;
    }
  },
  CONVERSATION_ACTIVITY_REGISTERED(state, payload) {
    state.newConversationActivity = payload;
  },
  ECHO_CONNECTION_UNAVAILABLE(state, payload) {
    state.echoConnectionLost = payload;
  },
  RECONNECT_CHANNEL(state) {
    state.reconnectChannel++;
  },
  NEW_IMPORT_STATS_RECEIVED(state, payload) {
    state.importStats = payload;
  },
  CLEAR_IMPORT_STATS(state) {
    state.importStats = {};
  },
  CHANGE_IMPORT_RUNNING_STATE(state, payload) {
    state.importRunning = payload;
  },
  PREVENT_IMPORT_TOAST_MESSAGE(state, payload) {
    state.preventImportToastMessage = payload;
  },
  NEW_BULK_SEND_PROGRESS_RECEIVED(state, payload) {
    state.bulkSendProgress = payload;
  },
  CLEAR_BULK_PROGRESS_STATS(state) {
    state.bulkSendProgress = {};
  },
  CHANGE_BULK_MESSAGES_RUNNING_STATE(state, payload) {
    state.bulkMessageRunningState = payload;
  },
  CLEAR_EXPORT_STATS(state) {
    state.exportStats = {};
  },
  CHANGE_EXPORT_RUNNING_STATE(state, payload) {
    state.exportRunning = payload;
  },
  NEW_EXPORT_STATS_RECEIVED(state, payload) {
    state.exportStats = payload;
  },
  SET_BUSINESS_AVAILABILITY(state, payload) {
    state.businessAvailabilityChange++;
    const targetBusiness = this.state.organisation.currentOrganisation.businesses.find(business => business.id === payload.business_uid);
    if (targetBusiness) {
      targetBusiness.available = payload.available;
    }
  },
  SET_USER_AVAILABILITY(state, payload) {
    // Updates the current user
    if (payload.user_uid === this.state.user.id && payload.organisationId === this.state.organisation.currentOrganisation.id) {
      this.state.organisation.currentOrganisation.user_availability.available = payload.available;
    }

    // updates list of all users including current user since it updates a different list than the block above
    const targetMember = this.state.organisation.organisationMembers.find(member => member.id === payload.user_uid);
    if (targetMember) {
      targetMember.available = payload.available;
    }
  },
  NEW_CONVERSATION_ACTIVITY(state, payload) {
    state.conversationActivity = payload;
  },
  CONVERSATION_READ_UPDATE(state, payload) {
    state.readUpdate = payload;
  },
  MARK_LAST_MESSAGE_TIME(state) {
    if (state.lastMessageTime && (Date.now() - state.lastMessageTime) > (3 * 60 * 1000)) {
      state.pusherTooOld = true;
    }
    state.lastMessageTime = Date.now();
  },
  CHANGE_ROUTE(state, payload) {
    state.newRoute = payload;
  },
};
